exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-3cc9521f]{width:30%}.list>span[data-v-3cc9521f]{margin-right:5px}.add[data-v-3cc9521f]{border:1px solid #d4d4d4;padding:10px 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer}.add>span[data-v-3cc9521f]{margin-left:15px}\n", ""]);

// exports
